import Glide from "@glidejs/glide";
let glide = null;

function initInlineImageSlider(id) {
    glide = new Glide('#' + id, {
        type: 'slider',
        rewind: false, 
        bound: true,
        startAt: 0,
        gap: 20,
        perView: 3,
        breakpoints: {
            900: {
                perView: 1,
                gap: 10,
            }
        }
    });
    
    glide.mount();
}

export function moveGlide(whichWay) {
    glide.go(whichWay);
}

window.initInlineImageSlider = initInlineImageSlider;